var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning",
    clipPath: "url(#clip0_904_9644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00233 1.19922C8.44608 1.19922 8.85545 1.43359 9.08045 1.81797L15.8305 13.318C16.0586 13.7055 16.0586 14.1836 15.8367 14.5711C15.6148 14.9586 15.1992 15.1992 14.7523 15.1992H1.25233C0.80545 15.1992 0.389826 14.9586 0.167951 14.5711C-0.0539244 14.1836 -0.0507994 13.7023 0.174201 13.318L6.9242 1.81797C7.1492 1.43359 7.55858 1.19922 8.00233 1.19922ZM8.00233 5.19922C7.5867 5.19922 7.25233 5.53359 7.25233 5.94922V9.44922C7.25233 9.86484 7.5867 10.1992 8.00233 10.1992C8.41795 10.1992 8.75233 9.86484 8.75233 9.44922V5.94922C8.75233 5.53359 8.41795 5.19922 8.00233 5.19922ZM9.00233 12.1992C9.00233 11.934 8.89697 11.6796 8.70943 11.4921C8.5219 11.3046 8.26754 11.1992 8.00233 11.1992C7.73711 11.1992 7.48275 11.3046 7.29522 11.4921C7.10768 11.6796 7.00233 11.934 7.00233 12.1992C7.00233 12.4644 7.10768 12.7188 7.29522 12.9063C7.48275 13.0939 7.73711 13.1992 8.00233 13.1992C8.26754 13.1992 8.5219 13.0939 8.70943 12.9063C8.89697 12.7188 9.00233 12.4644 9.00233 12.1992Z",
    fill: "#FFC512"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_904_9644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.199219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.64cafd19b927003f76927ccf3a982693.svg";
export { ForwardRef as ReactComponent };